import { AuthApi } from '@quadminds/client-apis/auth';
import { useMemo } from 'react';
import { useMutation } from 'react-query';

export const useSetCurrentOrganization = () => {
    const authApi = useMemo(() => new AuthApi(), []);
    return useMutation(async (id: string) => await authApi.setCurrentOrganization(id));
};
